import moment from 'moment';
import { companyMailerApi } from '../services';

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const LAUNCH_MAILER_RELEASE_DATE = '2022-08-20';
const MAILER_ROLES = ['staff', 'csm', 'csmmaster'];

const isWelcomeMailerAvailable = (launchDate) => {
  const date = moment(launchDate, 'YYYY-MM-DD', true);
  return Boolean(launchDate) && date.isValid() && moment().isSameOrAfter(date, 'day');
};

// Pre-launch runs until 30 days after the official launch email (90 days after launch when none was sent). Until then
// the Welcome mailer lives in Pre Launch; afterwards only in Engagement, and Pre Launch is gone.
const loadPrelaunchActive = ({ role, launchDate, isActive }, done) => {
  if (!(launchDate >= LAUNCH_MAILER_RELEASE_DATE)) return done(false);
  if ((isActive === 'inactive' && role === 'staff') || !MAILER_ROLES.includes(role)) return done(true);
  const today = moment().format('YYYY-MM-DD');
  companyMailerApi.post_pre_launch({},
    res => done(today < moment(res.data?.sent_at).add(30, 'days').format('YYYY-MM-DD')),
    () => done(today <= moment(launchDate).add(90, 'days').format('YYYY-MM-DD')));
};

export { EMAIL_REGEX, LAUNCH_MAILER_RELEASE_DATE, MAILER_ROLES, isWelcomeMailerAvailable, loadPrelaunchActive };
